import React from 'react';
import { CategoryPageContent, DishFirstFoodItemsSegmentFragment } from 'src/gqlReactTypings.generated.d';
import { SubCuisineIcon } from 'src/pages/consumer/dish-first/explore/components/PageHero/CuisineCategoryPageHero/SubCuisineHero';
import { SegmentHeaderSubtitle, SegmentHeaderTitle } from 'src/pages/consumer/dish-first/explore/styles';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { ScreenWidth, Spacing } from 'web-common/src/shared/styles';
import { SeeAllButton } from '../styles';

const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin: ${Spacing.QUADRUPLE} 0 ${Spacing.SINGLE};
  padding: ${Spacing.DOUBLE_HALF} ${Spacing.SINGLE} ${Spacing.NONE};
  gap: ${Spacing.SINGLE};

  ${minScreen(ScreenWidth.SMALL)} {
    flex-direction: row;
    justify-content: unset;
    gap: ${Spacing.DOUBLE};
  }
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  align-self: flex-end;

  padding-bottom: ${Spacing.SINGLE};

  height: min-content;
  width: 100%;
`;

const MinWidthSeeAll = styled(SeeAllButton)`
  width: 64px;
`;

interface IProps {
  className?: string;
  segment: DishFirstFoodItemsSegmentFragment;
  categoryPageContent: CategoryPageContent;
  showSeeAllButton?: boolean;
  handleSeeAllButtonClick: () => void;
}

export const ShefCuisineSegmentHeader: React.FC<IProps> = ({
  className,
  segment,
  categoryPageContent,
  showSeeAllButton = true,
  handleSeeAllButtonClick,
}): JSX.Element => {
  const { isSmallScreen } = useScreenContext();

  return (
    <Container className={className}>
      {categoryPageContent.illustrationUrl ? (
        <SubCuisineIcon
          src={categoryPageContent.illustrationUrl}
          alt={categoryPageContent.title}
          width={95}
          height={108}
          sourceWidth={95}
          sourceHeight={108}
        />
      ) : null}
      <RowContainer>
        <div className='flex flex-col gap-2'>
          <SegmentHeaderTitle>{categoryPageContent.title ?? segment.displayName}</SegmentHeaderTitle>
          <SegmentHeaderSubtitle>{categoryPageContent.subTitle}</SegmentHeaderSubtitle>

          {isSmallScreen && showSeeAllButton && segment.id !== 'ALL' && (
            <MinWidthSeeAll onClick={handleSeeAllButtonClick}>See all</MinWidthSeeAll>
          )}
        </div>

        {!isSmallScreen && showSeeAllButton && segment.id !== 'ALL' && (
          <MinWidthSeeAll className='ml-4' onClick={handleSeeAllButtonClick}>
            See all
          </MinWidthSeeAll>
        )}
      </RowContainer>
    </Container>
  );
};
